import React from "react";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Grid,
  IconButton,
  Tooltip,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { deleteJobById } from "../../../../../services/job";
import { toast } from "react-toastify";
import { getCurrentUser } from "../../../../../services/auth";
import CardActionArea from "@mui/material/CardActionArea";

const PendingJobList = ({ data, setData }) => {
  const user = getCurrentUser();

  const handleDelete = (id) => {
    const jobsCopy = [...data];
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this Job? This cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#FF0000",
        confirmButtonText: "Delete",
      }).then((res) => {
        if (res.isConfirmed) {
          deleteJobById(id, user.id).then((res) => {
            if (res.data && res.data.status === 1) {
              toast.error(res.data.message);
              const updatedJobs = data.filter((j) => j.id !== id);
              setData(updatedJobs);
            } else {
              toast.error(res.data.message);
            }
          });
        }
      });
    } catch (error) {
      if (error.response.data.statusCode === 404) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "This record may have already been deleted.",
        });
        setData(jobsCopy);
      }
    }
  };

  const navigate = useNavigate();
  const filteredSlides = data.filter((slide) => slide.pending);

  return (
    <Box>
      <Grid container spacing={2}>
        {filteredSlides.map((slide) => (
          <Grid key={slide.id} item xs={12} sm={6} md={4}>
            <Card
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                borderRadius: "10px",
                transition: "all .3s",
                "&:hover": {
                  boxShadow: "0px 0px 30px 1px rgba(0, 255, 117, 0.30)",
                },
              }}
            >
              <CardActionArea
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={slide.imageFileName}
                  alt="Slide Image"
                  sx={{
                    width: "100%",
                    backgroundColor: "#1a1a1a",
                    borderRadius: "10px 10px 0 0",
                    transition: "all .2s",
                    "&:hover": {
                      transform: "scale(1.1)",
                      borderRadius: "25px 25px 0 0",
                    },
                  }}
                />
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    color: "#fff",
                    borderRadius: "0 0 10px 10px",
                    p: 1,
                    paddingBottom: 0,
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    "& > :first-of-type": {
                      marginBottom: "8px",
                      borderBottomLeftRadius: "10px",
                      borderBottomRightRadius: "10px",
                      color: "#fff",
                    },
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    {slide.jobTitle} ({slide.category || "No Category"})
                  </Typography>
                </CardContent>
              </CardActionArea>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  p: 0,
                  zIndex: 1,
                }}
              >
                <Tooltip title="View" placement="left">
                  <IconButton
                    size="small"
                    color="info"
                    sx={{
                      borderRadius: 0,
                      background:
                        "radial-gradient(circle, rgba(218,213,213,0.6) 100%, rgba(245,245,245,2) 100%)",
                    }}
                    onClick={() =>
                      navigate(`job/edit/${slide.id}`)
                    }
                  >
                    <RemoveRedEyeIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PendingJobList;
